import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    readSimplifiedMapRendering,
    writeSimplifiedMapRendering,
} from '../../utils/map/mapRenderingMode';

export interface SettingsState {
    notifications: boolean;
    voiceReports: boolean;
    silentMode: boolean;
    summaryEnabled: boolean;
    summaryFrequency: string;
    simplifiedMapRendering: boolean;
    loaded: boolean;
}

const initialState: SettingsState = {
    notifications: true,
    voiceReports: false,
    silentMode: false,
    summaryEnabled: false,
    summaryFrequency: '15',
    simplifiedMapRendering: readSimplifiedMapRendering(),
    loaded: false,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        loadSettings: (state, action: PayloadAction<{ [key: string]: string }>) => {
            const settings = action.payload;

            state.notifications = settings['instant-notifications'] === 'true';
            state.voiceReports = settings['voice-reports'] === 'true';
            state.silentMode = settings['quiet-mode'] === 'true';
            state.summaryEnabled = settings['summary_enabled'] === 'true';
            state.summaryFrequency = settings['digest-frequency'] || '15';
            state.simplifiedMapRendering = readSimplifiedMapRendering();
            state.loaded = true;
        },
        setNotifications: (state, action: PayloadAction<boolean>) => {
            state.notifications = action.payload;
        },
        setVoiceReports: (state, action: PayloadAction<boolean>) => {
            state.voiceReports = action.payload;
        },
        setSilentMode: (state, action: PayloadAction<boolean>) => {
            state.silentMode = action.payload;
        },
        setSummaryEnabled: (state, action: PayloadAction<boolean>) => {
            state.summaryEnabled = action.payload;
        },
        setSummaryFrequency: (state, action: PayloadAction<string>) => {
            state.summaryFrequency = action.payload;
        },
        setSimplifiedMapRendering: (state, action: PayloadAction<boolean>) => {
            state.simplifiedMapRendering = action.payload;
            writeSimplifiedMapRendering(action.payload);
        },
    },
});

export const {
    loadSettings,
    setNotifications,
    setVoiceReports,
    setSilentMode,
    setSummaryEnabled,
    setSummaryFrequency,
    setSimplifiedMapRendering,
} = settingsSlice.actions;

export const settingsReducer = settingsSlice.reducer;
